export const REFERRER_POLICY = 'strict-origin-when-cross-origin';